const productLinks = [
  {
    image: "/static/img/wfm.png",
    link: "/workflow-manager",
    subTitle: "Boost productivity, reduce errors and get your team focused",
    title: "Gov ECMS",
  },
  {
    image: "/static/img/crm.png",
    link: "/products/customer-order-management",
    subTitle: "Manage the lifecycle of their goods from order to delivery",
    title: "Customer Order Management",
  },
  {
    image: "/static/img/ims.png",
    link: "/products/inventory-management-system",
    subTitle: "Manage and track inventory real time, all in one place",
    title: "Asset Management ",
  },
  {
    image: "/static/img/ucg.png",
    link: "/products/unified-collections-gateway",
    subTitle:
      "Real-time aggregation of revenue collections for different payment channels",
    title: "Unified Collections Gateway",
  },
  {
    image: "/static/img/merchant-logo.png",
    link: "/merchant",
    subTitle: "Connect with resellers, find suppliers and trade together.",
    title: "1GOV Merchant",
  },
];

// const businessNeedLinks = [
//   {
//     link: "/business-need/inventory",
//     title: "Inventory and stock management",
//   },
//   // {
//   //   link: "#!",
//   //   title: "Online Store",
//   // },
//   {
//     link: "/business-need/operations-management",
//     title: "Operation process management",
//   },
//   // {
//   //   link: "#!",
//   //   title: "Sales Order Management",
//   // },
//   {
//     link: "/business-need/supplier-management",
//     title: "Supplier Management",
//   },
//   {
//     link: "/supply-chain",
//     title: "Supply Chain Management",
//   },
// ];

const businessSizeLinks = [
  // {
  //   link: "/business-size/small-business",
  //   title: "Small businesses",
  // },
  {
    link: "/medium-businesses",
    title: "Medium businesses",
  },
  {
    link: "/enterprise",
    title: "Enterprise",
  },
];

const learningCenterLinks = [
  
  {
    link: "/resources/policy-statement",
    title: "Policy Statement",
  },
  {
    link: "https://galaxybackbone.com.ng/resources/",
    title: "GBB Support",
  },
  // {
  //   link: "/resources/ebook",
  //   title: "eBooks",
  // },
  // {
  //   link: "#!",
  //   title: "News & Events",
  // },
  // {
  //   link: "#!",
  //   title: "Case Studies",
  // },
];

const supportLinks = [
  // {
  //   link: "#",
  //   title: "FAQs",
  //   external: true,
  // },
  {
    link: "#",
    title: "Help Centre",
    external: true,
  },
];

const serviceLinks = [
  {
    link: "#",
    title: "Contact",
    external: true,
  },
  // {
  //   link: "#!",
  //   title: "Partners",
  // },
];

export const solutionsMenu = {
  title: "Solutions",
  menuList: [
    {
      title: "products",
      links: productLinks,
    },
    {
      title: "BY BUSINESS Size",
      links: businessSizeLinks,
    },
  ],
};

export const resourceMenu = {
  title: "Resource",
  menuList: [
    {
      // title: "RESOURCES",
      links: learningCenterLinks,
    },
    // {
    //   title: "SUPPORT",
    //   links: supportLinks,
    // },
    // {
    //   title: "SERVICE",
    //   links: serviceLinks,
    // },
  ],
};
